module.exports = __webpack_public_path__ + "img/taiwanpay.9b027518.png";